/* Use a Hungarian share action instead of Ghost Portal's untranslated menu. */
(function () {
    const shareButton = document.querySelector('.gh-button-share');
    if (!shareButton) return;

    const status = document.createElement('span');
    status.className = 'mss-share-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.style.cssText = 'position:fixed;z-index:9999;left:50%;bottom:24px;transform:translateX(-50%);padding:12px 18px;border-radius:999px;background:#102a43;color:#fff;font:600 15px/1.3 sans-serif;box-shadow:0 6px 24px #102a4340;opacity:0;pointer-events:none;transition:opacity .2s';
    document.body.appendChild(status);

    let statusTimer;
    function announce(message) {
        status.textContent = message;
        status.style.opacity = '1';
        clearTimeout(statusTimer);
        statusTimer = setTimeout(function () { status.style.opacity = '0'; }, 2400);
    }

    shareButton.addEventListener('click', async function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (navigator.share) {
            try {
                await navigator.share({title: document.title, url: window.location.href});
                return;
            } catch (error) {
                if (error.name === 'AbortError') return;
            }
        }

        try {
            await navigator.clipboard.writeText(window.location.href);
            announce('A hivatkozás a vágólapra került.');
        } catch (error) {
            announce('A hivatkozás másolása nem sikerült.');
        }
    }, true);
})();
